import React from 'react';
import PropTypes from 'prop-types';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { CalculatorStepItem } from 'site-modules/calculators/components/calculator-step-item/calculator-step-item';
import { CalculatorRowItem } from 'site-modules/calculators/components/calculator-row-item/calculator-row-item';

export function GasGuzzlerResultsStep({ savings = 0, breakEvenPoint = 0 }) {
  return (
    <CalculatorStepItem stepName="Results">
      <CalculatorRowItem title="Amount Saved on Gas" subtitle="(per month)" isResultCalculations>
        <span data-test="gas-guzzler-result-amount">{formatPriceString(savings)}</span>
      </CalculatorRowItem>
      <CalculatorRowItem
        title="Breakeven Point"
        subtitle="(Number of months to breakeven and begin saving money on gas)"
        isResultCalculations
      >
        <span data-test="gas-guzzler-result-breakeven-point">{breakEvenPoint}</span>
      </CalculatorRowItem>
    </CalculatorStepItem>
  );
}

GasGuzzlerResultsStep.propTypes = {
  savings: PropTypes.number,
  breakEvenPoint: PropTypes.number,
};
